var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B4250;}\n\t.st1{fill:#1A8F3F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,82.5c-66.2,0-122.2,54.3-135,67.5c12.8,13.2,68.8,67.5,135,67.5s122.2-54.3,135-67.5 C272.2,136.8,216.2,82.5,150,82.5z M150,207.8c-31.8,0-57.8-26-57.8-57.8s26-57.8,57.8-57.8s57.8,26,57.8,57.8 S181.8,207.8,150,207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,107.6c-1.3,0-2.2,0-3.1,0c-1.3,0-2.6,0.9-3.5,1.8c-0.9,1.3-0.9,2.6-0.4,4c2.6,7.9,1.3,17.6-3.5,23.8 c-4.4,5.7-10.6,8.8-18.5,8.8c-2.6,0-5.3-0.4-7.5-1.3c-1.3-0.4-2.6,0-4,0.9c-1.3,0.9-1.8,2.2-1.8,3.5v0.4c0,23.4,19,42.4,42.4,42.4 s42.4-19,42.4-42.4C192.4,126.6,173.4,107.6,150,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,82.1c0.9,1.3,2.2,2.2,4,2.2c0.9,0,1.3,0,2.2-0.4c2.2-1.3,3.1-4,1.8-6.2l-5.7-10.1 c-1.3-2.2-4-3.1-6.2-1.8c-2.2,1.3-3.1,4-1.8,6.2L73.2,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101,69.3c0.4,1.8,2.2,3.1,4.4,3.1c0.4,0,0.9,0,1.3,0c2.2-0.9,3.5-3.1,3.1-5.7l-3.5-11 c-0.9-2.2-3.1-3.5-5.7-3.1c-2.2,0.9-3.5,3.1-3.1,5.7L101,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,66.2h0.4c2.2-0.4,4.4-2.2,4-4.9l-1.3-11.5c-0.4-2.2-2.2-4-4.9-4c-2.2,0.4-4.4,2.2-4,4.9l1.3,11.5 C131,64.9,132.8,66.2,135,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,66.2h0.4c2.2,0,4-1.8,4.4-4l1.3-11.5c0.4-2.2-1.3-4.4-4-4.9c-2.6-0.4-4.4,1.3-4.9,4l-1.3,11.5 C160.6,64,162.4,66.2,164.6,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.2,72.4c0.4,0,0.9,0,1.3,0c1.8,0,3.5-1.3,4.4-3.1l3.5-11c0.9-2.2-0.4-4.9-3.1-5.7 c-2.2-0.9-4.9,0.4-5.7,3.1l-3.5,11C189.7,68.8,191,71.5,193.2,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.6,83.8c0.9,0.4,1.3,0.4,2.2,0.4c1.8,0,3.1-0.9,4-2.2l5.7-10.1c1.3-2.2,0.4-4.9-1.8-6.2 c-2.2-1.3-4.9-0.4-6.2,1.8l-5.7,10.1C217.5,79.9,218.4,82.5,220.6,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,216.2c-2.2-1.3-4.9-0.4-6.2,1.8l-5.7,10.1c-1.3,2.2-0.4,4.9,1.8,6.2c0.9,0.4,1.3,0.4,2.2,0.4 c1.8,0,3.1-0.9,4-2.2l5.7-10.1C82.5,220.1,81.6,217.5,79.4,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.8,227.6c-2.2-0.9-4.9,0.4-5.7,3.1l-3.5,11c-0.9,2.2,0.4,4.9,3.1,5.7c0.4,0,0.9,0,1.3,0 c1.8,0,3.5-1.3,4.4-3.1l3.5-11C110.3,231.2,109,228.5,106.8,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.4,233.8c-2.6-0.4-4.4,1.3-4.9,4l-1.3,11.5c-0.4,2.2,1.3,4.4,4,4.9h0.4c2.2,0,4-1.8,4.4-4l1.3-11.5 C139.4,236,137.6,233.8,135.4,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,233.8c-2.2,0.4-4.4,2.2-4,4.9l1.3,11.5c0.4,2.2,2.2,4,4.4,4h0.4c2.2-0.4,4.4-2.2,4-4.9l-1.3-11.5 C169,235.1,167.2,233.4,164.6,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199,230.7c-0.9-2.2-3.1-3.5-5.7-3.1c-2.2,0.9-3.5,3.1-3.1,5.7l3.5,11c0.4,1.8,2.2,3.1,4.4,3.1 c0.4,0,0.9,0,1.3,0c2.2-0.9,3.5-3.1,3.1-5.7L199,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.8,217.9c-1.3-2.2-4-3.1-6.2-1.8c-2.2,1.3-3.1,4-1.8,6.2l5.7,10.1c0.9,1.3,2.2,2.2,4,2.2 c0.9,0,1.3,0,2.2-0.4c2.2-1.3,3.1-4,1.8-6.2L226.8,217.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.4ba88e22fc4d32a1cec7fcdb6883be29.svg";
export { ForwardRef as ReactComponent };